/**
 * Environment constants - matches REACT_APP_ENV from .env files (Create React App).
 * Used by: .env.development, .env.staging, .env.testing, .env.production
 */
export const ENV = {
  LOCAL: "local",
  DEV: "development",
  STAGING: "staging",
  TESTING: "testing",
  PROD: "production",
};

/** Current environment from process.env.REACT_APP_ENV */
export const CURRENT_ENV = process.env.REACT_APP_ENV;
